import { updateMerchant } from '@api';
import { Button, Dropdown, FormInput, ProfileImage } from '@basqet-dashboard/common/components';
import { APP_NAME } from '@basqet-dashboard/common/config';
import { useSessionStorage } from '@basqet-dashboard/common/hooks';
import { businessSchema, formatErrorMessage } from '@basqet-dashboard/common/utils';
import { yupResolver } from '@hookform/resolvers/yup';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

const BusinessDetailsForm = ({ user, countries, setUser }) => {
  const [merchant, setMerchant] = useSessionStorage(APP_NAME);
  const [isLoading, setIsLoading] = useState(false);
  const { merchantUser, token } = merchant;

  const { merchantId } = user;
  const {
    register,
    handleSubmit,
    formState: { errors, isDirty }
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(businessSchema)
  });

  const onSubmit = async (body) => {
    const { country_id: countryId, phone_number } = body;

    if (Number(countryId) === user?.countryId && phone_number === user?.phoneNumber) {
      return toast.warn("You didn't make any changes");
    }
    setIsLoading(true);
    try {
      await updateMerchant({ country_id: Number(countryId), merchantId, phone_number });
      setIsLoading(false);
      merchantUser.phoneNumber = phone_number;
      merchantUser.countryId = Number(countryId);
      const updatedMerchant = {
        token,
        merchantUser
      };
      setUser(merchantUser);
      setMerchant(updatedMerchant);
      toast.success('Business details updated successfully');
    } catch (error) {
      formatErrorMessage(error);
      setIsLoading(false);
    }
  };

  return (
    <div className="business__form">
      <div className="business__image">
        <ProfileImage location="settings-edit" />
      </div>

      <div className="form__grid">
        <FormInput
          data-testid="business-first-name-input"
          label="First name"
          placeholder="First name"
          name="firstName"
          type="text"
          value={user && user.firstName}
          readOnly
          disabled
        />
        <FormInput
          data-testid="business-last-name-input"
          label="Last name"
          placeholder="Last name"
          name="lastName"
          type="text"
          value={user && user.lastName}
          readOnly
          disabled
        />
      </div>
      <FormInput
        data-testid="business-name-input"
        label="Business name"
        placeholder="Enter your business name"
        name="businessName"
        type="text"
        value={user && user.merchantName}
        readOnly
        disabled
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Dropdown
          data-testid="business-country-select"
          formLabel="Country of residence"
          placeholder="Enter your country of residence"
          name="country_id"
          options={countries}
          defaultValue={user && user.countryId}
          error={errors.country_id && errors.country_id.message}
          register={register('country_id')}
        />
        <FormInput
          data-testid="business-phone-input"
          label="Phone number"
          placeholder="Enter your business phone number"
          name="phoneNumber"
          type="text"
          defaultValue={user && user.phoneNumber}
          error={errors.phone_number && errors.phone_number.message}
          {...register('phone_number')}
        />
        <Button
          data-testid="business-details-save-button"
          isFull
          disabled={!isDirty}
          type="submit"
          isLoading={isLoading}>
          Save changes
        </Button>
      </form>
    </div>
  );
};

BusinessDetailsForm.propTypes = {
  setUser: PropTypes.func,
  user: PropTypes.object,
  countries: PropTypes.array
};

export { BusinessDetailsForm };
